import React from 'react';

import { h3 } from '../../styles/typography.module.scss';

import { clsName } from '../../utils/helpers';
import ButtonLink from '../../components/common/ButtonLink';
import styles from './RedBlockSection.module.scss';

const RedBlockSection = (props) => {
  const { text, secondLine, button } = props;
  const hasSecondLine = !!secondLine;
  return (
    <div className={clsName(styles.RedBlock, hasSecondLine && styles.RedBlock_multiline)}>
      <div>
        <div className={clsName(h3, styles.Text)}>{text}</div>
        {hasSecondLine && <div className={styles.SecondLine}>{secondLine}</div>}
      </div>
      <div className={styles.Button}>
        <ButtonLink
          href={button.url}
          as={button.urlAs}
          label={button.text}
          text={button.text}
          type="white"
          external={button.external}
        />
      </div>
    </div>
  );
};

export default RedBlockSection;
